module.exports = __webpack_public_path__ + "heart-classic-chrome.3624701ebfe0b642f769.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/workpath0/src/assets/img/heart-classic-chrome.svg
// module id = ../../../../../src/assets/img/heart-classic-chrome.svg
// module chunks = main